<template>
  <div>
    <div class="text-center">
      <!-- <v-autocomplete
        v-model="selectShozoku"
        :items="shozokuList"
        label="事業所を選択してください！"
        item-text="sname"
        item-value="incode"
        class="mx-4 attendance-sel"
        flat
        outlined
        @change="changeSelectShozoku()"
      >
      </v-autocomplete> -->

      <v-form v-model="valid" ref="form" @submit.prevent="login">
        <v-text-field
          class="mx-4 my-8"
          v-model="id"
          label="職員番号"
          prepend-inner-icon="mdi-account"
          outlined
        ></v-text-field>
      </v-form>

      <p class="text-h3">
        {{ date.toLocaleDateString() }}{{ &nbsp; }}
        {{ date.toLocaleTimeString() }}
      </p>
      <!-- <v-text-field
        v-model="id"
        class="mx-5"
        label="ログインID"
        prepend-inner-icon="mdi-account"
        outlined
        rounded
        :rules="[Rules.Required]"
      ></v-text-field> -->
    </div>

    <div class="text-center ma-10">
      <Btn
        class="mr-16"
        icon="mdi-briefcase-clock"
        color="success"
        x-big
        rounded
        @click="setAttendance(false)"
        fontSize="50"
        >出勤</Btn
      >
      <Btn
        class="ml-16"
        icon="exit-run"
        color="error"
        x-big
        rounded
        @click="setAttendance(true)"
        fontSize="50"
        >退勤</Btn
      >
    </div>

    <div class="text-center">
      <!-- <Btn
        class="mx-5"
        middle
        rounded
        icon="briefcase-edit"
        value="修正"
        fontSize="30"
        @click="click(Actions.Fix)"
      /> -->
      <!-- <Btn
        class="mx-5"
        middle
        rounded
        icon="file-table"
        value="勤務実績"
        fontSize="30"
        @click="click(Actions.Roster)"
      />
      <Btn
        class="mx-5"
        middle
        rounded
        icon="chart-timeline"
        value="個別シフト"
        font-size="26"
        @click="click(Actions.Shift)"
      /> -->
      <!-- <Btn
        class="mx-5"
        middle
        rounded
        icon="mdi-account-key"
        value="PWD変更"
        font-size="30"
        v-if="!isShow()"
        @click="click(Actions.Password)"
      />
      <Btn
        class="mx-5"
        middle
        rounded
        icon="mdi-car"
        value="移動登録"
        font-size="30"
        v-if="isShow()"
        @click="click(Actions.WelfareMove)"
      /> -->
    </div>
  </div>
</template>

<script>
//mixins
import Common from "@/mixins/common";
import ShowDialogs from "@/mixins/showDialogs";
import Api from "@/mixins/api";
import axios from "axios";

//dialogs
import AttendanceDialog from "@/views/dialogs/AttendanceDialog";
import TemporaryLogin from "@/views/dialogs/TemporaryLogin.vue";
import AttendanceFixTemporaryDialog from "@/views/dialogs/AttendanceFixTemporaryDialog";
import AttendanceDetail from "@/models/AttendanceDetail";
import TemporaryAttendanceDetailDialog from "@/views/dialogs/TemporaryAttendanceDetailDialog";
import TemporaryShiftDialog from "@/views/dialogs/TemporaryShiftDialog";
import TemporaryPasswordChangeDialog from "@/views/dialogs/TemporaryPasswordChangeDialog";
import TemporaryDistanceDialog from "@/views/dialogs/TemporaryDistanceDialog";

import { BUSYO_CODE as BusyoCode } from "@/defines";

const DATE = new Date();

const Actions = {
  Eat: 0,
  Break: 1,
  MidBreak: 2,
  Fix: 3,
  Roster: 4,
  Shift: 5,
  Password: 6,
  WelfareMove: 7
};

export default {
  name: "Login",
  mixins: [Common, ShowDialogs, Api],
  data: () => ({
    date: DATE,
    targetdate: `${DATE.getFullYear()}-${DATE.getMonth() +
      1}-${DATE.getDate()}`,
    Actions,
    selectShozoku: "",
    shozokuList: [],
    shozokuListReadOnly: false,
    audio1: null,
    audio2: null
  }),
  methods: {
    isShow() {
      if (this.$store.state.shozokuCode1 === BusyoCode.WELFARE) {
        return true;
      }
      return false;
    },
    async click(action) {
      console.log(action);

      if (!this.selectShozoku && !this.id) {
        this.$error("事業所を選択してください！");
        return;
      }

      if (!this.$store.state.user.login) {
        const result = await this.$showDialog(TemporaryLogin);
        console.log(result);

        if (!result) return;
      }

      switch (action) {
        case Actions.Fix:
          await this.fix();
          break;
        case Actions.Roster:
          await this.roster();
          break;
        case Actions.Shift:
          await this.shift();
          break;
        case Actions.Password:
          await this.pwdchange();
          break;
        case Actions.WelfareMove:
          await this.setdistance();
          break;
      }
    },
    async fix() {
      await this.updateDate();
      const ts = this.date.getTime();
      const param = {
        //incode: this.$store.state.incode,
        incode: this.selectShozoku,
        userincode: this.$store.state.user.incode,
        targetdate: this.targetdate
      };

      const encode = encodeURI(JSON.stringify(param));
      console.log("encode", encode);

      const resp = await this.$get(
        this.Paths.attendance,
        "temporary=" + encode
      );

      const args = new AttendanceDetail(
        resp.recordid ? resp.recordid : "",
        resp.employee ? resp.employee : this.$store.state.user.incode,
        resp.affiliation ? resp.affiliation : this.selectShozoku,
        resp.shiftid ? resp.shiftid : "",
        resp.shiftpatternid ? resp.shiftpatternid : "",
        this.targetdate,
        ts,
        resp.start ? resp.start : "",
        resp.end ? resp.end : "",
        resp.distance ? resp.distance : "0",
        resp.inover ? resp.inover : "",
        resp.lateleave ? resp.lateleave : "",
        resp.amount ? resp.amount : "",
        resp.breakflg ? resp.breakflg : "",
        resp.daycount ? resp.daycount : "",
        resp.nightcount ? resp.nightcount : "",
        resp.hadmeal ? resp.hadmeal : "0",
        resp.careShu ? resp.careShu : "0",
        resp.careKbn ? resp.careKbn : "0",
        resp.timeKbn ? resp.timeKbn : "0"
      );
      await this.$showDialog(AttendanceFixTemporaryDialog, { args });
    },
    async roster() {
      await this.updateDate();

      const param = {
        //incode: this.$store.state.incode,
        incode: this.selectShozoku,
        userincode: this.$store.state.user.incode,
        targetdate: this.targetdate
      };

      const encode = encodeURI(JSON.stringify(param));
      console.log("encode", encode);
      try {
        const item = await this.$get(
          this.Paths.attendance,
          "tmpattendance=" + encode
        );
        await this.$showDialog(TemporaryAttendanceDetailDialog, { args: item });
      } catch (e) {
        console.log(e);
        this.$error(e.message);
        this.$store.commit("user/logout");
      }
    },
    async shift() {
      const date = this.$getCrossServiceDate();

      const param = {
        userincode: this.$store.state.user.incode,
        targetmonth:
          parseInt(date.split("-")[0]) + "-" + parseInt(date.split("-")[1])
      };

      const encode = encodeURI(JSON.stringify(param));
      console.log("encode", encode);

      try {
        const item = await this.$get(this.Paths.shift, "tmpshift=" + encode);
        await this.$showDialog(TemporaryShiftDialog, { args: item });
      } catch (e) {
        console.log(e);
        this.$error(e.message);
        this.$store.commit("user/logout");
      }
    },
    async pwdchange() {
      try {
        const param = {
          userincode: this.$store.state.user.incode,
          usercode: this.$store.state.user.code
        };
        await this.$showDialog(TemporaryPasswordChangeDialog, { args: param });
      } catch (e) {
        console.log(e);
        this.$error(e.message);
        this.$store.commit("user/logout");
      }
    },
    async setdistance() {
      try {
        const queryparam = {
          userincode: this.$store.state.user.incode,
          targetdate: this.targetdate
        };
        const encode = encodeURI(JSON.stringify(queryparam));
        const records = await this.$get(
          this.Paths.tmpDistance,
          "query=" + encode
        );

        const param = {
          userincode: this.$store.state.user.incode,
          usercode: this.$store.state.user.code,
          dataheaders: records.headers,
          databodies: records.body
        };
        await this.$showDialog(TemporaryDistanceDialog, { args: param });
      } catch (e) {
        console.log(e);
        this.$error(e.message);
        this.$store.commit("user/logout");
      }
    },
    async setAttendance(isEnd = false) {
      // 出退勤メッセージクリア
      this.$store.state.supplement = "";
      // if (!this.selectShozoku && !this.id) {
      //   this.$error("事業所を選択してください！");
      //   return;
      // }
      if (!this.id) {
        // ダイアログ表示後に所属選択を初期化。登録はthis.$store.state.workIncodeから取得。
        // ただし、1件のみの場合は初期化を行わない。
        if (this.shozokuList.length > 1) this.selectShozoku = "";
        const result = await this.$showDialog(AttendanceDialog, { isEnd });
        console.log(result);
        //職員番号が入力されている場合
      } else {
        // const shaininfo = this.getShain1();
        //現在選択されている事業所と基本所属の事業所を比較して異なれば警告
        let loginid = this.id;
        loginid = ("000000" + this.id).slice(-6);

        let deviceId = "";
        const ipInfo = await axios.get("https://api.ipify.org?format=json");
        deviceId = ipInfo.data.ip;

        const data = {
          loginId: loginid,
          password: "Hgs9437767QrFreeReq",
          shozokuIncode: this.$store.state.workIncode,
          isEnd: isEnd,
          deviceId: deviceId
        };
        try {
          const encode = encodeURI(JSON.stringify(data));
          const result = await this.$get(
            this.Paths.attendanceCheck,
            "query=" + encode
          );
          const ShaNm = result[0];
          const LogInShozoku = result[1];
          const check = result[2];
          if (result) {
            const Out = "から退勤";
            let InOut = "に出勤";
            const Outm = "退勤";
            let InOutm = "出勤";
            const ShaNm = result[0];
            const LogInShozoku = result[1];
            const check = result[2];
            console.log("check", check); //打刻存在チェック
            if (isEnd) {
              InOut = Out;
              InOutm = Outm;
            }
            const res = await this.$confirm2(
              ShaNm +
                "さんが、" +
                LogInShozoku +
                InOut +
                "しようとしています。\nよろしいでしょうか。？",
              "確認",
              "custom-confirm-dialog"
            );
            if (!res) {
              this.audio2.play();
              this.id = "";
              const mess = await this.$warning(
                InOutm + "処理をやり直してください。"
              );
              if (this.shozokuList.length > 1) {
                this.selectShozoku = "";
                this.$store.state.workIncode = "";
              }
              return;
            } else {
              if (!isEnd) {
                if (check != false && check === "true") {
                  console.log("check_true");
                  this.audio2.play();
                  const message = "本日この現場では、既に出勤しています。";
                  this.id = "";
                  await this.$error(message);
                  return;
                } else if (check != "false" && check != "true") {
                  // errorで返ってきたとき
                  this.$error(
                    "エラーが発生しました。\n 読取QRが正しいことを確認ください。"
                  );
                  return;
                }
              } else {
                if (check != false && check === "true") {
                  console.log("check_true");
                  this.audio2.play();
                  const message = "本日この現場では、既に退勤しています。";
                  this.id = "";
                  await this.$error(message);
                  return;
                } else if (check != "false" && check != "true") {
                  // errorで返ってきたとき
                  this.$error(
                    "エラーが発生しました。\n 読取QRが正しいことを確認ください。"
                  );
                  return;
                }
              }
              this.audio1.play();
            }
          }
        } catch (e) {
          this.$error(e.message);
          this.$close();
        }
        let resHour = "";
        let resMin = "";
        let resSec = "";
        let ShaName = "";
        let mess = "";
        try {
          const path = !isEnd
            ? this.Paths.attendanceStart
            : this.Paths.attendanceEnd;
          const result = await this.$post(
            path + "?cache_delete=True&t=" + Math.random(),
            data
          );
          if (result) {
            this.disp = " " + result.displaymessage;
            const disp = this.disp.split(":");
            resHour = disp[1] + "時";
            resMin = disp[2] + "分";
            resSec = disp[3].slice(0, 2) + "秒";
            ShaName = disp[3].slice(2, disp[3].length) + "さん";
          }
        } catch (e) {
          this.$error(e.message);
          if (e.message === "認証トークンの有効期限切れです") {
            this.$store.commit("logout");
            this.$store.commit("user/logout");
            // this.$close();
            this.$router.push({ name: "Login" });
          }
        }
        if (ShaName.includes("打刻済")) {
          mess = "打刻済です。";
        } else {
          if (!isEnd) {
            (mess =
              "よろしくお願いします。\n 出勤者：" +
              ShaName +
              " \n 出勤時刻：" +
              resHour +
              resMin +
              resSec),
              "出勤完了";
          } else {
            (mess =
              "お疲れ様でした。\n 退勤者：" +
              ShaName +
              " \n 退勤時刻：" +
              resHour +
              resMin +
              resSec),
              "退勤完了";
          }
        }
        await this.$info(mess);
        this.id = "";
        if (this.shozokuList.length > 1) {
          this.selectShozoku = "";
        }
      }
    },
    async updateDate() {
      this.date = new Date();
      this.targetdate = `${this.date.getFullYear()}-${this.date.getMonth() +
        1}-${this.date.getDate()}`;
    },
    async setShozokuList() {
      try {
        const queryparam = { incode: this.$store.state.incode };
        const encode = encodeURI(JSON.stringify(queryparam));
        const records = await this.$get(
          this.Paths.shozokuGroup,
          "query=" + encode
        );
        this.shozokuList = records;
        this.$store.state.workIncode = "";
        if (records.length === 1) {
          this.shozokuListReadOnly = true;
          this.selectShozoku = records[0].incode;
          this.$store.state.workIncode = records[0].incode;
        }
      } catch (e) {
        console.log(e);
        this.$error(e.message);
        this.$store.commit("user/logout");
      }
    },
    changeSelectShozoku() {
      // 事業所選択の変更時
      this.$store.state.workIncode = this.selectShozoku;
      this.$store.state.supplement = "";
    }
  },
  async created() {
    console.log("created");
    //await this.setShozokuList();
    const sound = require("@/assets/sound/QR.mp3") + "";

    const result = await axios.get(sound, {
      responseType: "blob",
      headers: {
        "Content-Type": "audio/mpeg"
      }
    });
    const url = URL.createObjectURL(result.data); //this.data);
    this.audio1 = new Audio(url);

    // audio2も同様にロードする
    const sound2 = require("@/assets/sound/beep.mp3") + "";
    const result2 = await axios.get(sound2, {
      responseType: "blob",
      headers: {
        "Content-Type": "audio/mpeg"
      }
    });
    const url2 = URL.createObjectURL(result2.data);
    this.audio2 = new Audio(url2);
  },
  mounted() {
    setInterval(() => {
      this.date = new Date();
    }, 500);
  }
};
</script>

<style scoped>
.margin-row {
  margin-top: 0px;
}
.dialog-padding {
  padding-top: 0px;
}
.custom-confirm-dialog {
  width: 600px !important;
  height: 400px !important;
}
.my-8 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}
</style>
